import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { PermissionStore } from '@core/store/permission.store';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs';

@Injectable()
export class RoutePermissionResolver  {
  constructor(private permissionStore: PermissionStore, private permissionService: PermissionService) {
     // This is intentional
  }

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const pagePermissions = this.permissionService.getPagePermission(route.data).pipe(
      tap(res => {
        this.permissionStore.setStore(res['data']);
      }),
      catchError(_error => of([]))
    );
    const lookupPermissions = this.permissionService.getPageLookupPermission().pipe(
      tap(res => {
        this.permissionStore.setStore(res['data'], 'LP');
      }),
      catchError(_error => of([]))
    );
    return forkJoin([pagePermissions, lookupPermissions]);
  }
}
